module.exports = __webpack_public_path__ + "img/imagen.4936369e.svg";